import * as React from 'react';
import { ICustomPropertiesSectionProps } from './types';
import { CLASS_CARD_DETAILS_SECTION } from '../../../constants';
import {
    CARD_CUSTOM_ACTIONS,
    CARD_CUSTOM_ADD,
    CARD_CUSTOM_CANCEL,
    CARD_CUSTOM_EDIT,
    CARD_CUSTOM_HIDE,
    CARD_CUSTOM_SHOW,
    CARD_SECTION_CUSTOM
} from './constants';
import { SettingsSection } from '../../../../../base/components/SettingsSection/SettingsSection';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { CLASS_CARD_CUSTOM } from '../constants';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { CLASS_SETTINGS_SECTION_EMPTY } from '../../../../../base/components/SettingsSection/constants';
import './_CustomPropertiesSection.scss';
import { Button, ButtonDropdown, Divider, Icon, SelectList, SelectListItem } from 'kui';
import { getAsidePanelTooltip } from '../../../../asidePanel/helpers/getAsidePanelTooltip';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
import {
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER,
    ID_ASIDE_PANEL_PORTAL
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import { CustomPropertiesElements } from '../CustomPropertiesElements/CustomPropertiesElements';
import { IBoardCardCustomOption, IBoardCardCustomProperty } from '../../../../../../../store/customProperties/types';
import {
    CustomPropertiesFormHOC
} from '../../../../../base/components/CustomProperties/hocs/CustomPropertiesFormHOC/CustomPropertiesFormHOC';
import { CLASS_CUSTOM_PROPERTY_ITEM } from '../../../../../base/components/CustomProperties/components/constants';
import { root } from '../../../../../../../store/constants';
import { GOOGLE_SPACING } from '../../../../../../../const';

//@ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardCustomPropertiesSection`) : null;

export function CustomPropertiesSection ({
    elements: _elements,
    isDefaultProperty,
    isEssentialFeature,
    isHideEmpty,
    isProFeature,
    isShow,
    sectionType,
    onAdd,
    onClickCancel,
    onClickEdit,
    onClose,
    onConfirmDelete,
    onHideEmpty,
    onOpen,
    onSave,
    onToggleEdit,
}: ICustomPropertiesSectionProps) {
    const { openedProperty, addShowedProperty, cardId, boardId, isMobile, showedProperties, isCommentsColumn } = React.useContext(AsidePanelContext);

    if (analyzeRender) analyzeRender.call(`CustomPropertiesSection ${cardId}`);

    const isPopup = sectionType === ESettingsSectionType.POPUP;
    const isReadonly = sectionType === ESettingsSectionType.READONLY;

    const classSection = CLASS_CARD_DETAILS_SECTION;
    const className = CLASS_CARD_CUSTOM;
    const classEmpty = CLASS_SETTINGS_SECTION_EMPTY;

    const [isShowSecion, setShowSection] = React.useState(false);
    const [isOpened, setOpened] = React.useState(isPopup);
    const [isActionsOpened, setActionsOpened] = React.useState(null);
    const [isEdit, _setEdit] = React.useState(false);
    const [newProperty, setNewProperty] = React.useState(null);
    const [changedElements, setChangedElements] = React.useState(null);
    const [elements, setElements] = React.useState(_elements);

    const isEmpty = !elements.length;

    const setEdit = (value: boolean) => {
        _setEdit(value);
        if (onToggleEdit && value !== isEdit) {
            onToggleEdit(value);
        }
    };

    const handleSave = (elements: IBoardCardCustomProperty[]) => {
        onSave(elements);
        setEdit(false);
    };

    const onAddOpened = () => {
        setOpened(true);
        if (onOpen) onOpen();
        onCancel();
    };

    const onAddClosed = (
        force: boolean = false // for x in popup
    ) => {
        setOpened(false);
        if ((force || !isPopup) && onClose) onClose();
    };

    const onEditHandler = () => {
        setEdit(true);
        if (!isPopup) setOpened(false);
        onClickEdit();
    };

    const onCancel = () => {
        setEdit(false);
        setElements(elements);
    };

    const onClickCancelHandler = () => {
        onCancel();
        onClickCancel();
    };

    const onActionClick = (action: () => void) => {
        action();
        setActionsOpened(false);
    };

    React.useEffect(() => {
        setElements(_elements)
    }, [_elements]);

    React.useEffect(() => {
        if (isEmpty) { // при удалени последнего
            onCancel(); // закрыть Edit
        }
    }, [isEmpty]);

    React.useEffect(() => {
        if (isShow && !isPopup || isDefaultProperty) {
            setShowSection(true);
            addShowedProperty(EAsidePanelProperty.CARD_CUSTOM, isCommentsColumn);
        }
    }, [elements, isDefaultProperty]);

    React.useEffect(() => {
        if (!isPopup) return;
        const onResize = () => {
            const button = document.querySelector(`.${CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER}--custom`) as HTMLElement;
            if (button) {
                const bottom = Math.round(button.getBoundingClientRect().bottom);
                const dropdown = document.querySelector('.card-details-section--custom') as HTMLElement
                if (dropdown) {
                    dropdown.style.maxHeight = isMobile ? null
                        : root._innerHeight - bottom + GOOGLE_SPACING * 5 + 'px'; // плюс часть сдвига из _AsidePanelActionsButtons.scss
                }
            }
        };

        onResize();

        root.addEventListener('resize', onResize);
        return () => {
            root.removeEventListener('resize', onResize);
        }
    }, []);

    if (
        !elements && sectionType === ESettingsSectionType.READONLY ||
        (!isShow && openedProperty !== EAsidePanelProperty.CARD_CUSTOM && !showedProperties.has(EAsidePanelProperty.CARD_CUSTOM))
    ) {
        return;
    }

    const EmptyIcon = require('!!@svgr/webpack!./empty.svg').default;

    const isNewProperty = newProperty &&
        (!newProperty.options || newProperty.options.find((option: IBoardCardCustomOption) => option.value));

    return (
        <SettingsSection
            addTitle={CARD_CUSTOM_ADD}
            isProFeature={isProFeature}
            isEssentialFeature={isEssentialFeature}
            notBlurClasses={[CLASS_CUSTOM_PROPERTY_ITEM + '-type-select-dropdown']}
            isCloseOnHeader
            addComponent={
                /**
                 * если на доске нет кастом полей, то в попапе рисуем обычный addComponent
                 * если есть кастом поля, то мы не знаем, чего хочет юзер, добавить новое поле или заполнить существующее
                 */
                (!isPopup || isEmpty) && isOpened ?
                    <CustomPropertiesFormHOC
                        cardId={cardId}
                        boardId={boardId}
                        isNew
                        isCloseOnAdd={!isPopup}
                        names={elements.map(element => element.name)}
                        isPopup={isPopup}
                        onClose={onAddClosed}
                        setNewProperty={setNewProperty}
                    />
                    : <div />
            }
            className={`
                ${classSection}
                ${classSection}--custom
                ${isPopup ? classSection + '--popup' : ''}
                ${!isPopup && isEmpty ? classEmpty : ''}
                ${isEmpty && isOpened ? classEmpty + '-opened' : ''}
                ${isEdit ? classSection + '-custom--editing' : ''}
                ${isEdit && !changedElements ? classSection + '-custom--save-disabled' : ''}
                ${isNewProperty && isOpened ? classSection + '-custom--save-new' : ''}
            `}
            isAddWide={!isEdit}
            isOpened={isOpened}
            title={CARD_SECTION_CUSTOM}
            titleButton={isReadonly || isEmpty && !isOpened || isPopup && isEdit // спрятать крест в попапе, чтоб не было 2 креста рядом
                ? null
                : isEdit ?
                    <>
                        <Button
                            className={className + '__edit'}
                            tooltip={getAsidePanelTooltip({
                                value: CARD_CUSTOM_CANCEL
                            })}
                            variant={'icon'}
                            onClick={onClickCancelHandler}
                        >
                            <Icon size={24} xlink={'close'} />
                        </Button>
                        <Button
                            variant={'icon'}
                            className={className + '__save'}
                            onClick={() => {
                                handleSave(changedElements);
                            }}
                        >
                            <Icon xlink={'done-circle'} size={16} />
                        </Button>
                    </>
                    : isOpened ?
                        <Button
                            variant={'icon'}
                            className={className + '__save-new'}
                            onClick={() => {
                                onAdd(newProperty.name, newProperty.type, newProperty.options);
                                onAddClosed();
                            }}
                        >
                            <Icon xlink={'done-circle'} size={16} />
                        </Button>
                        : <ButtonDropdown
                        className={className + '__actions'}
                        opened={isActionsOpened}
                        onOpen={() => setActionsOpened(true)}
                        onClose={() => setActionsOpened(false)}
                        directionHorizontal={'right'}
                        directionVertical={'auto'}
                        portal
                        portalId={ID_ASIDE_PANEL_PORTAL}
                    >
                        <Button
                            tooltip={getAsidePanelTooltip({
                                value: CARD_CUSTOM_ACTIONS
                            })}
                            variant={'icon'}
                        >
                            <Icon size={24} xlink={'more'} />
                        </Button>
                        <SelectList fixActive={false}>
                            <SelectListItem
                                icon={'pen'}
                                onClick={() => onActionClick(onEditHandler)}
                                iconSize={24}
                            >
                                {CARD_CUSTOM_EDIT}
                            </SelectListItem>
                            <Divider />
                            <SelectListItem
                                className={className + '__list-item'}
                                onClick={() => onActionClick(onHideEmpty)}
                                iconSize={24}
                            >
                                <span className={className + '__icon'}>
                                    <EmptyIcon />
                                </span>
                                {isHideEmpty ? CARD_CUSTOM_SHOW : CARD_CUSTOM_HIDE}
                            </SelectListItem>
                        </SelectList>
                    </ButtonDropdown>
            }
            sectionType={sectionType}
            onAddOpened={onAddOpened}
            onClickTitle={onAddClosed}
            onAddClosed={() => {
                onAddClosed(true);
                setNewProperty(null);
            }}
        >
            {isPopup && !isEmpty &&
                <CustomPropertiesFormHOC
                    cardId={cardId}
                    boardId={boardId}
                    isCloseOnAdd={!isPopup}
                    names={elements.map(element => element.name)}
                    isPopup={isPopup}
                />
            }
            <CustomPropertiesElements
                elements={elements}
                isEdit={isEdit}
                isHideEmpty={isHideEmpty}
                isAddOpened={isOpened}
                sectionType={sectionType}
                onConfirmDelete={onConfirmDelete}
                onEdit={onEditHandler}
                onSave={handleSave}
                setChangedElements={setChangedElements}
            />
        </SettingsSection>
    );
}
